import Vue from 'vue'
import VueQriously from 'vue-qriously'
import VueClipboard from 'vue-clipboard2'
import Vuesax from 'vuesax'
import VueQrcodeReader from 'vue-qrcode-reader'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css
import 'material-icons/iconfont/material-icons.css'
import 'vuesax/dist/vuesax.css'

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VueQriously)
Vue.use(VueClipboard)

Vue.prototype.$NETWORK_ID = process.env.NETWORK_ID

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

Vue.use(VueQrcodeReader)

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#e6242b'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js